import { useState, useEffect } from 'react';
import userInfo from 'hub-http/userInfo';
import Raven from 'raven-js';
const useUserInfo = () => {
  const [userInfoData, setUserInfoData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  useEffect(() => {
    setIsLoading(true);
    userInfo().then(auth => {
      setUserInfoData(auth);
      setIsLoading(false);
    }).catch(fetchError => {
      setError(fetchError);
      setIsLoading(false);
      Raven.captureException(new Error('ui-brand-identity-lib: Auth state fetch failed', {
        cause: fetchError
      }));
    });
  }, []);
  return {
    userInfo: userInfoData,
    isLoading,
    error
  };
};
export const usePortalIsUngated = gate => {
  const {
    userInfo: userInfoData,
    isLoading,
    error
  } = useUserInfo();
  if (isLoading) {
    return null;
  }
  if (error || !userInfoData) {
    return false;
  }
  return userInfoData.gates.includes(gate);
};
export default useUserInfo;